export const NATURA_BRAZIL_INTEGRATION_CLASS = 'NaturaBrazilCustom';
